import React from 'react';
import './book-event-form-guests.scss';
import { EventParticipant } from '../../../../../store/events/eventTypes';
import DefaultUserImage from '../../../../../assets/images/avatars/avatar-blank.png';
import AvatarGroup from '../../../../overwritten-core/layouts/components/avatar-group';

type Props = {
  participants: EventParticipant[];
};

const BookEventFormGuests = (props: Props) => {
  return (
    <div className="book-event-guests">
      {props.participants && (
        <AvatarGroup
          data={props.participants.slice(0, 5).map((participant) => ({
            title: participant.user?.fullName,
            img: participant?.user?.image || DefaultUserImage,
          }))}
        />
      )}
      {props.participants && props.participants.length > 5 && (
        <div className="book-event-more-guests">
          +{props.participants.length - 5}
        </div>
      )}
    </div>
  );
};

export default BookEventFormGuests;
